import portfolio from '../images/s1.png';
import portfolio1 from '../images/s2.png';
import portfolio2 from '../images/s3.png';

const Sdata=[
    {
        imgsrc:portfolio,
    },
    {
        imgsrc:portfolio1,
        
    },
    {
        imgsrc:portfolio2,
    },
]
export default Sdata;